import { DateTime } from "luxon"
import { Widget, WidgetHeader, WidgetBody, WidgetFooter } from "../ui/Widget"
import InfoItem from "../common/InfoItem"
import GoogleMapsAddressLink from "../common/GoogleMapsAddressLink"
import StartLocationAuditButton from "./StartLocationAuditButton"

export default function LocationInformationWidget({ location, isFetching }) {
  const attributes = location?.attributes ?? {}

  const formatDate = (date) => date ? DateTime.fromISO(date).toLocaleString() : 'Not Scheduled'

  return (
    <Widget>
      <WidgetHeader title="Trailer Location Information" showSpinner={isFetching} />
      {location && (
        <>
          <WidgetBody>
            <div className="grid grid-cols-2 w-full text-left">
              <InfoItem
                title="Address"
                data={
                  <GoogleMapsAddressLink
                    linkText={attributes.address}
                    address={attributes.address}
                  />
                }
              />
              <InfoItem title="Audit Unit Count" data={attributes.audit_unit_count} />
              <InfoItem title="Next Audit Date" data={formatDate(attributes.next_audit_date)} />
              <InfoItem title="Last Audit Date" data={formatDate(attributes.last_audit_date)} />
            </div>
          </WidgetBody>
          <WidgetFooter>
            <StartLocationAuditButton location={location} />
          </WidgetFooter>
        </>
      )}
    </Widget>
  )
}
